import script from "./AddRoomsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRoomsSection.vue?vue&type=script&setup=true&lang=js"

import "./AddRoomsSection.vue?vue&type=style&index=0&id=702ee255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-702ee255"]])

export default __exports__